<template>
<v-container>
	<v-layout>
		<v-flex md12>
			<Citizenship v-model="settings.citizenship" />
		</v-flex>
	</v-layout>
	<v-layout>
		<Item
			:list="settings.educationTypes"
			@add="addEduType"
			@remove="removeEduType"
			@edit="editEduType"
			:label="$t('workers.edu_type')"
		/>
	</v-layout>
	<v-layout>
		<Item
			:list="settings.scanTypes"
			@add="addScanType"
			@remove="removeScanType"
			@edit="editScanType"
			:label="$t('workers.scan_types')"
		/>
	</v-layout>
	<v-layout>
		<Item
			:only-value="true"
			:list="settings.tituls1"
			@add="addTitul1"
			@remove="removeTitul1"
			@edit="changeTitul1"
			:label="$t('employers.person_titul1')"
		/>
	</v-layout>
	<v-layout>
		<Item
			:only-value="true"
			:list="settings.tituls2"
			@add="addTitul2"
			@remove="removeTitul2"
			@edit="changeTitul2"
			:label="$t('employers.person_titul2')"
		/>
	</v-layout>

	<v-layout>
		<Item
			:list="settings.insuranceCompanies"
			@add="addInsuranceCompany"
			@remove="removeInsuranceCompany"
			@edit="changeInsuranceCompany"
			:label="$t('common.insurance_company')"
		/>
	</v-layout>
</v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Item from '../Item'
import Citizenship from '../Citizenship'

export default {
	components: {
		Item,
		Citizenship
	},
	methods: {
		...mapMutations({
			addEduType: 'settings/addEduType',
			removeEduType: 'settings/removeEduType',
			editEduType: 'settings/changeEduType',

			addScanType: 'settings/addScanType',
			editScanType: 'settings/changeScanType',
			removeScanType: 'settings/removeScanType',

			addTitul1: 'settings/addTitul1',
			changeTitul1: 'settings/changeTitul1',
			removeTitul1: 'settings/removeTitul1',

			addTitul2: 'settings/addTitul2',
			changeTitul2: 'settings/changeTitul2',
			removeTitul2: 'settings/removeTitul2',

			addInsuranceCompany: 'settings/addInsuranceCompany',
			changeInsuranceCompany: 'settings/changeInsuranceCompany',
			removeInsuranceCompany: 'settings/removeInsuranceCompany'
		})
	},
	computed: {
		...mapState({
			settings: ({ settings }) => settings.settings
		})
	}
}
</script>
